import { text, TextDecorations } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";
import Italic from "../../icons/italic.svg?react";
import ItalicActive from "../../icons/italic-active.svg?react";
import { fireWrapSelectionEvent } from "../../lib/editor/events";
import { IsInPortrait } from "../../state/selectors";
import { CanApplyTextFormatting, MousedOverTextHelper } from "../../state/uiAtoms";
import { StyledTextControl } from "../StyledControl";

function ItalicControl() {
  const setTextHelper = useSetRecoilState(MousedOverTextHelper);
  const isInPortrait = useRecoilValue(IsInPortrait);
  const canFormat = useRecoilValue(CanApplyTextFormatting);

  const handleClick = () => {
    if (!canFormat) return;
    fireWrapSelectionEvent(TextDecorations.italic);
  };

  const mouseOver = () => {
    setTextHelper(canFormat
      ? text.textControls.italic
      : "Select text to apply italic");
  };

  const mouseLeave = () => {
    setTextHelper(undefined);
  };

  return (
    <>
      <StyledTextControl
        $dim={!canFormat}
        onClick={handleClick}
        onMouseOver={mouseOver}
        onMouseLeave={mouseLeave}
        aria-label={text.textControls.italic}
        aria-disabled={!canFormat}
        $isInPortrait={isInPortrait}
        data-testid="italic-control"
      >
        {canFormat ? (
          <ItalicActive aria-hidden="true" focusable="false" className="format-text-control italic" />
        ) : (
          <Italic aria-hidden="true" focusable="false" className="format-text-control italic" />
        )}
      </StyledTextControl>
    </>
  );
}

export default ItalicControl;
